/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['form[_ngcontent-%COMP%], h3[_ngcontent-%COMP%]{color:#333}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3NoYWl6YXIvUHJvamVjdHMvTUFNUFUvTXlHb3YvcG9ydGFsLWZlL3NyYy9hcHAvbG9naW4vbG9naW4uY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9zaGFpemFyL1Byb2plY3RzL01BTVBVL015R292L3BvcnRhbC1mZS9zcmMvYXBwL2xvZ2luL2xvZ2luLmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/login/login.component.css.shim.ngstyle.ts